/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuyoutRights } from './buyoutRights';


export interface UsageRights { 
    _id: string;
    buyoutRightsTitle: string;
    orderNumber?: string;
    creatorDepartment?: string;
    creatorContact?: string;
    campaignStart?: string;
    producerAgency?: string;
    producerAgencyContact?: string;
    producingDateYear?: string;
    supplierLibrary?: string;
    title?: string;
    composer?: string;
    performer?: string;
    label?: string;
    speakerAgency?: string;
    contactPerson?: string;
    talentName?: string;
    distribution?: string;
    durationPeriod?: string;
    expiryDate?: string;
    firstAiring?: string;
    version?: Array<string>;
    imageSource?: string;
    additionalInformation?: string;
    imageTitle?: string;
    referenceNumber?: string;
    importantInstruction?: string;
    buyoutRights?: Array<BuyoutRights>;
}

